import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
            data-testid="theme-toggle-btn"
            className={`relative w-9 h-9 rounded-full bg-[var(--tk-toggle-bg)] hover:opacity-80 flex items-center justify-center transition active:scale-90 ${className}`}
        >
            <Sun
                className={`absolute w-4 h-4 text-[var(--tk-text)] transition-all duration-300 ${
                    isDark ? "opacity-0 rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"
                }`}
            />
            <Moon
                className={`absolute w-4 h-4 text-[var(--tk-text)] transition-all duration-300 ${
                    isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-50"
                }`}
            />
        </button>
    );
}
